// Helpers for Play Store rating + local session/mock counters.
// Used by Dashboard nudge, Profile button, and MockTest auto-prompt.

const PACKAGE_ID = "in.brimi.hg.twa";
const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PACKAGE_ID}`;
const MARKET_URL = `market://details?id=${PACKAGE_ID}`;

// Storage keys
const K_SESSIONS = "brimi_session_count";
const K_MOCKS = "brimi_mocks_done";
const K_RATE_PROMPTED = "brimi_rate_prompted";
const K_RATE_DISMISSED = "brimi_rate_dismissed_at";
const K_WALKTHROUGH_DONE = "brimi_walkthrough_done";

// Bump session count once per browser tab open (App boot).
export function bumpSessionCount() {
  try {
    const n = parseInt(localStorage.getItem(K_SESSIONS) || "0", 10) + 1;
    localStorage.setItem(K_SESSIONS, String(n));
    return n;
  } catch {
    return 0;
  }
}

export function getSessionCount() {
  return parseInt(localStorage.getItem(K_SESSIONS) || "0", 10);
}

export function incrementMocksDone() {
  const n = parseInt(localStorage.getItem(K_MOCKS) || "0", 10) + 1;
  localStorage.setItem(K_MOCKS, String(n));
  return n;
}

export function getMocksDone() {
  return parseInt(localStorage.getItem(K_MOCKS) || "0", 10);
}

export function hasBeenPromptedToRate() {
  return localStorage.getItem(K_RATE_PROMPTED) === "1";
}

export function markRatePrompted() {
  localStorage.setItem(K_RATE_PROMPTED, "1");
}

export function dismissRateNudge() {
  localStorage.setItem(K_RATE_DISMISSED, String(Date.now()));
}

export function wasRateNudgeDismissed() {
  return !!localStorage.getItem(K_RATE_DISMISSED);
}

export function setWalkthroughDone() {
  localStorage.setItem(K_WALKTHROUGH_DONE, "1");
}

export function isWalkthroughDone() {
  return localStorage.getItem(K_WALKTHROUGH_DONE) === "1";
}

// Open Play Store — deep-link into the store app on Android (TWA opens Play natively),
// falls back to the web listing for iOS/desktop.
export function openPlayStoreRating() {
  const ua = navigator.userAgent || "";
  const isAndroid = /android/i.test(ua);
  try {
    if (isAndroid) {
      // Use the intent URL that opens Play Store app directly
      window.location.href = MARKET_URL;
      // Fallback to https URL after a short delay in case market:// isn't handled
      setTimeout(() => {
        window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
      }, 800);
    } else {
      window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
    }
  } catch {
    window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
  }
}

export const PLAY_STORE_LINK = PLAY_STORE_URL;
